// src/config/api.js

// export const BASE_URL1 = "http://192.168.1.103/lifetimecreation/backend";
export const BASE_URL = "https://www.lifetimecreation.in/backend";
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
export const API = {
  /* ================= AUTH ================= */

  LOGIN: "https://lifetimedesign.in/LtcJsonAPI.asmx/IsValidLogin",

  FORGOT_PASSWORD: `${BASE_URL}/forgot_password.php`,

  VERIFY_OTP: `${BASE_URL}/verify_otp.php`,

  CHANGE_PASSWORD: `${BASE_URL}/change_pass.php`,
};
